<template>
  <img class="qrcode-image" :src="image_link">
</template>

<script>
export default {
    props: {
        link: String,
        size: {
            type: Number,
            default: 128
        }
    },
    computed: {
        image_link() {
            return `https://api.qrserver.com/v1/create-qr-code/?size=${this.size}x${this.size}&data=${this.link}`;
        }
    }
}
</script>

<style scoped>
.qrcode-image {
    height: 18vh;
    display: block;
    margin-left: 2.2vh;
    width: 48.5vh;
    border-radius: 1vh;
}
</style>